import { alpha } from "@mui/material/styles";
import type { Theme, Components } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function CssBaseline(theme: Theme): Components<Theme> {
  const thumb = alpha(theme.palette.text.secondary, 0.36);
  const thumbHover = alpha(theme.palette.text.secondary, 0.56);
  const track = "transparent";

  return {
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
          scrollbarWidth: "thin",
          // Firefox: scrollbar thumb/track transparent until hovered, so it
          // reads as auto-hidden like macOS's overlay scrollbars instead of
          // permanently visible like Windows/Linux Chrome's classic ones.
          scrollbarColor: `transparent ${track}`,
          transition: "scrollbar-color 0.3s ease",
        },
        "*:hover": {
          scrollbarColor: `${thumb} ${track}`,
        },
        html: {
          width: "100%",
          height: "100%",
          WebkitOverflowScrolling: "touch",
        },
        body: {
          width: "100%",
          height: "100%",
        },
        "*::-webkit-scrollbar": {
          width: 6,
          height: 6,
        },
        // Chrome/Safari/Edge: keep the scrollbar's own box reserved (no
        // layout shift) but hide the track/thumb until hovered.
        "*::-webkit-scrollbar-track, *::-webkit-scrollbar-thumb": {
          visibility: "hidden",
          transition: "visibility 0.3s ease",
        },
        "*:hover::-webkit-scrollbar-track, *:hover::-webkit-scrollbar-thumb": {
          visibility: "visible",
        },
        "*::-webkit-scrollbar-thumb": {
          borderRadius: 8,
          backgroundColor: thumb,
          border: "2px solid transparent",
          backgroundClip: "padding-box",
        },
        "*::-webkit-scrollbar-thumb:hover": {
          backgroundColor: thumbHover,
        },
        "*::-webkit-scrollbar-track": {
          backgroundColor: track,
        },
        "*::-webkit-scrollbar-corner": {
          backgroundColor: "transparent",
        },
        "#root": {
          width: "100%",
          height: "100%",
        },
        input: {
          "&[type=number]": {
            MozAppearance: "textfield",
            "&::-webkit-outer-spin-button": {
              margin: 0,
              WebkitAppearance: "none",
            },
            "&::-webkit-inner-spin-button": {
              margin: 0,
              WebkitAppearance: "none",
            },
          },
        },
        img: {
          display: "block",
          maxWidth: "100%",
          borderStyle: "none",
        },
      },
    },
  };
}
